<template>
  <div>
    <el-row
      class="flex-container-balance"
      style="padding-bottom: 0px; margin-bottom: 0px"
    >
      <el-col :span="12">
        <!--<h4>Proveedor</h4>-->
        <el-row :gutter="1">
          <el-col :span="9" :offset="1">
            <el-select
              size="mini"
              v-model="value"
              :loading="loading_Balance_Data"
              filterable
              clearable
              placeholder="Proveedor"
              @change="onSupplierChanging"
              class="supliers_select"
            >
              <el-option
                v-for="item in dataSuppliers"
                :key="item.supplierId"
                :label="item.supplierName"
                :value="item.supplierId"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              icon="el-icon-refresh"
              size="mini"
              v-if="supplier"
              @click="OpenUpdateSupplierAccountDrawer"
              >Actualizar cuentas por cobrar</el-button
            >
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row :gutter="20" type="flex" justify="end">
          <el-col :span="6" :offset="1">
            <!--<h4>filtro diferencias</h4>-->
            <el-select
              size="mini"
              v-model="DiffSelected"
              :loading="loading_Balance_Data"
              filterable
              clearable
              placeholder="Filtro diferencias"
              @change="onDiffChanging"
              class="supliers_select"
            >
              <el-option
                v-for="(item, index) in DiffOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <rabbey-toolbox
            filter-placeholder="Buscar por nombre"
            filterables
            @filter-search="search = $event"
          />
        </el-row>
      </el-col>
    </el-row>
    <!-- <el-row>
      <rabbey-table3
        ref="companyTable"
        :search="search"
        :border="true"
        :stripe="true"
        :columns="Columns"
        v-loading="loading_Balance_Data"
        :data="DiffFilteredDataMaster"
        :actions="BalanceReportActions"
        @rtable-push-action="onActionSelected"
        :class-table="{
          'table-box': true,
          'card-base': true,
          'card-shadow--medium': false
        }"
        :show-summary="true"
        :pageSizes="[10, 20, 50, 100, 200, 500]"
        :summary-method="getSummariesEmpresa"
      />
    </el-row> -->

    <el-row>
      <rabbey-table3
        ref="companyTable"
        :search="search"
        :border="true"
        :stripe="true"
        :columns="ColumnsCompanyBalanceTable"
        :data="CompanyBalanceData"
        :class-table="{
          'table-box': true,
          'card-base': true,
          'card-shadow--medium': false
        }"
        :show-summary="true"
        :pageSizes="[10, 20, 50, 100, 200, 500]"
        :summary-method="getSummariesEmpresa"
      />
    </el-row>

    <ClientBalanceReportDetailed
      :key="detailKey"
      ref="clientBalanceReportDetailed"
      :showDrawer="showClientBalanceReportDetailed"
      :CurrentClienData="ClientData"
      @OncloseDetail="OnCloseClientBalanceReportDetailed"
    />
    <ClientPagoProveedoresReport
      :key="detailKeyPagoProveedores"
      ref="clientPagoProveedoresReport"
      :showDrawer="showClientPagoProveedoresReport"
      :CurrentClienData="ClientData"
      @OncloseDetail="OnCloseClientPagoProveedoresReport"
    />
    <UpdateSupplierAccount
      v-if="supplier"
      ref="UpdateSupplierAccount"
      :showDrawer="showUpdateSupplierAccountDrawer"
      :CurrentClienData="ClientData"
      :supplier="supplier"
      @OncloseDetail="OnCloseUpdateSupplierAccount"
    />

    <TotaldeConsumosDetail
      :key="detailConsumosKey"
      ref="totaldeConsumosDetail"
      :showDrawerTotalConsumos="showDrawerTotalConsumos"
      :CurrentClienData="ClientData"
      :ClienId="clientId"
      @closeTotal="OnCloseDetailTotalConsumos"
    />

    <RecargaTotalReportDetailed
      :key="detailRecargaKey"
      ref="RecargaTotalReportDetailed"
      :showDrawerRecarga="showDrawerRecarga"
      :CurrentClienData="ClientData"
      :ClientID="clientId"
      @OncloseDetail="OnCloseDetailRecarga"
    />
    <CxCDiferenceDetail
      :key="dialogCxCKey"
      ref="CxCDiferenceDetail"
      :DialogShow="dialogShow"
      :RowData="rowData"
      @OnDialogClose="onDialogClose"
    />
    <ReporteClientes
      :key="detailDataCliente"
      ref="ReporteClientes"
      :CurrentClienData="ClientData"
      :ClientID="clientId"
      :showDrawerDataCliente="showDrawerDataCliente"
      @OncloseDetailCliente="OnCloseDetailCliente"
    />
  </div>
</template>

<script>
import {
  Columns,
  BalanceReportActions,
  ColumnsCompanyBalanceTable
  /*,
  ColumnsServices,
  ColumnsCustomer,
  ColumnsTerminales
  */
} from "../columnsTables/BalanceReportColumns";

//import { mapState, mapGetters } from "vuex";
import { formatMonto } from "@/utils";
import ClientBalanceReportDetailed from "@/views/apps/ncfmovil/Reports/Detailled_Reports/ClientBalanceReportDetailed.vue";
import TotaldeConsumosDetail from "@/views/apps/ncfmovil/Reports/Detailled_Reports/TotaldeConsumosDetail.vue";
import ClientPagoProveedoresReport from "@/views/apps/ncfmovil/Reports/Detailled_Reports/ClientPagoProveedoresReport.vue";
import UpdateSupplierAccount from "@/views/apps/ncfmovil/Reports/Detailled_Reports/UpdateSupplierAccount.vue";
//IMPORT QUE TRAE EL COMPONENTE RECARGA TOTAL
import RecargaTotalReportDetailed from "./Detailled_Reports/RecargaTotalReportDetailed.vue";
import CxCDiferenceDetail from "@/views/apps/ncfmovil/Reports/Detailled_Reports/CxCDiferenceDetail.vue";
//import CardcountTerminal from "@/views/apps/ncfmovil/CardsTerminal.vue";
//import { formatDate, formatArrayToElSelect } from "@/utils";
//import api from "@/api";
import ReporteClientes from "@/views/apps/ncfmovil/Reports/Detailled_Reports/ReporteClientes.vue";

export default {
  name: "SUPPLIER_BALANCE_REPORT",
  components: {
    ClientBalanceReportDetailed,
    TotaldeConsumosDetail,
    ClientPagoProveedoresReport,
    RecargaTotalReportDetailed,
    CxCDiferenceDetail,
    UpdateSupplierAccount,
    ReporteClientes
  },
  created: async function () {
    this.dataSuppliers = await this.GetAllSuppliers();
    await this.$store.dispatch("getAllCompany");
  },
  mounted: async function () {
    await this.GetBalanceCompanyData();
    await this.GetBalanceReportData();
  },

  data() {
    return {
      Columns,
      ColumnsCompanyBalanceTable,
      BalanceReportActions,
      SupplierBalanceDataMaster: [],
      loading_Balance_Data: false,
      loading_Data: false,
      showDrawer: false,
      showDrawerTotalConsumos: false,
      showClientBalanceReportDetailed: false,
      showClientPagoProveedoresReport: false,
      showUpdateSupplierAccountDrawer: false,
      showDrawerRecarga: false,
      showDrawerDataCliente: false,
      dataSuppliers: [],
      supplier: null,
      supliersloading: false,
      ClientData: {},
      clientId: 0,
      rowData: {},
      dialogShow: false,
      /*
      suplierId: 0,
      */
      detailKey: 0,
      detailKeyPagoProveedores: -1,
      detailConsumosKey: 1,
      detailRecargaKey: 2,
      detailDataCliente: 3,
      dialogCxCKey: 100,

      /*
      ColumnsServices,
      ColumnsCustomer,
      ColumnsTerminale,
      */
      search: "",
      value: "",
      DiffSelected: "All",
      DiffFilteredDataMaster: [],
      DiffOptions: [
        {
          value: "All",
          label: "Todos con o sin diferencias de Balances"
        },
        {
          value: "Diff",
          label: "Tiene diferencias de Balances"
        },
        {
          value: "NoTDiff",
          label: "No Tiene diferencias de Balances"
        }
      ],

      CompanyBalanceData: []
    };
  },
  methods: {
    formatMonto,
    //formatArrayToElSelect,

    before() {
      this.$store.dispatch("hide", false);
    },
    hanlderClose() {},
    getSummariesEmpresa(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index < 4 && index != 1) {
          return;
        }
        if (index === 1) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index < 6) {
          return;
        }
        if (index === 6) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    async onSupplierChanging(supplierId) {
      this.GetBalanceReportData(supplierId);
      const data = this.dataSuppliers.find((x) => x.supplierId == supplierId);
      this.supplier = {
        Id: data.supplierId,
        Name: data.supplierName,
        Rnc: data.RNC_Empresa
      };
    },
    async onDiffChanging(concept) {
      switch (concept) {
        case "All": {
          this.DiffFilteredDataMaster = this.SupplierBalanceDataMaster;
          break;
        }
        case "Diff": {
          this.DiffFilteredDataMaster = this.SupplierBalanceDataMaster.filter(
            (balanceData) => balanceData.balanceDiff !== 0
          );
          break;
        }
        case "NoTDiff": {
          this.DiffFilteredDataMaster = this.SupplierBalanceDataMaster.filter(
            (balanceData) => balanceData.balanceDiff === 0
          );
          break;
        }
        default: {
          break;
        }
      }
    },
    async GetAllSuppliers() {
      this.supliersloading = true;
      let Suppliers = [];
      await this.$http
        .get(`/api/tennos/GetAllSuppliersNotSucursal`)
        .then((resp) => {
          Suppliers = resp.data;
          //console.log(resp.data)
          /*
          console.log(
            "SupplierBalanceDataMaster: ",
            this.SupplierBalanceDataMaster
          );
          */
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.supliersloading = false;
        });
      return Suppliers;
    },
    async GetBalanceReportData(SupplierId = null) {
      this.loading_Balance_Data = true;
      this.loading_Data = true;
      await this.$http
        .get(
          `/api/tennos/GetSupplierBalanceReportMaster?EmpresaId=${SupplierId}`
        )
        .then((resp) => {
          this.SupplierBalanceDataMaster = resp.data;
          this.SupplierBalanceDataMaster.forEach((client) => {
            client.OpenDetail = this.OpenDetail;
            client.OpenDetailTotalConsumos = this.OpenDetailTotalConsumos;
            client.OpenClientPagoProveedoresReport =
              this.OpenClientPagoProveedoresReport;
            client.OpenDetailRecarga = this.OpenDetailRecarga;
            client.OpenDetailCxCDiference = this.OpenDetailCxCDiference;
          });
          this.DiffFilteredDataMaster = this.SupplierBalanceDataMaster;
          /*
          console.log(
            "SupplierBalanceDataMaster: ",
            this.SupplierBalanceDataMaster
          );
          */
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading_Balance_Data = false;
          this.loading_Data = false;
        });
      //console.log("Master Report: ", await this.SupplierBalanceDataMaster)
    },

    async GetBalanceCompanyData() {
      await this.$http //GetCompanyBalance
        .get(`/api/tennos/GetCompanyBalance`)
        .then((resp) => {
          this.CompanyBalanceData = resp.data;
          this.CompanyBalanceData.forEach((dataC) => {
            dataC.OpenDetailDataCliente = this.OpenDetailDataCliente;
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {});
    },
    OpenDetail(row) {
      //console.log("funciona opendetail", row.clientid," ", row.supplierId);
      /*
      this.clientId = row.clientid;
      this.suplierId = row.supplierId;
      */
      this.ClientData = row;
      this.showClientBalanceReportDetailed = true;
      this.detailKey++;
    },
    OpenDetailTotalConsumos(row) {
      this.ClientData = row;
      this.clientId = row.clientid;
      this.showDrawerTotalConsumos = true;
      this.detailConsumosKey++;
    },
    OpenDetailRecarga(row) {
      this.ClientData = row;
      this.clientId = row.clientid;
      this.showDrawerRecarga = true;
      this.detailRecargaKey++;
    },
    OnCloseDetail() {
      this.showDrawer = false;
    },
    OnCloseDetailTotalConsumos() {
      this.showDrawerTotalConsumos = false;
      this.detailConsumosKey++;
    },
    OpenClientPagoProveedoresReport(row) {
      this.ClientData = row;
      this.showClientPagoProveedoresReport = true;
      this.detailKeyPagoProveedores--;
    },
    OpenUpdateSupplierAccountDrawer() {
      if (!this.supplier) {
        return;
      }
      this.showUpdateSupplierAccountDrawer = true;
    },
    OpenDetailCxCDiference(val) {
      this.rowData = val;
      //this.rowData = row;
      this.dialogShow = true;
      this.dialogCxCKey++;
      console.log(this.dialogShow);
    },
    OpenDetailDataCliente(row) {
      this.ClientData = row;
      this.clientId = row.empresaid;
      this.showDrawerDataCliente = true;
      this.detailDataCliente++;
    },

    OnCloseClientPagoProveedoresReport() {
      this.showClientPagoProveedoresReport = false;
    },
    OnCloseUpdateSupplierAccount() {
      this.showUpdateSupplierAccountDrawer = false;
    },
    OnCloseClientBalanceReportDetailed() {
      this.showClientBalanceReportDetailed = false;
    },
    OnCloseDetailRecarga() {
      this.showDrawerRecarga = false;
      this.detailRecargaKey++;
    },
    OnCloseDetailCliente() {
      this.showDrawerDataCliente = false;
      this.detailDataCliente++;
    },
    onActionSelected(action) {
      //console.log("action: ", action);

      switch (action.command) {
        case "update-balance-command": {
          break;
        }
        case "update-CxC-command": {
          //console.log("action.row: ", action.row);
          this.rowData = action.row;
          this.dialogShow = true;

          break;
        }
      }
    },

    // onDialogClose(val)
    onDialogClose() {
      //console.log("onDialogClose: ", val)
      this.dialogShow = false;
      this.dialogCxCKey++;
    }
  }
};
</script>

<style lang="css" scoped>
.flex-container-balance {
  display: flex;
  /*height: 200px;*/
  align-items: center;
}

.supliers_select {
  min-width: 60%;
}
</style>
